<template>
    <!--    Built on Video.js Player pass in the notes -->
    <v-card outlined flat  v-if="notes" >
        <div style="position:absolute;top:15px;right:15px;z-index:2;" v-if="selected.length>0">
            <v-badge
                    bordered
                    overlap
                    color="awesome"
                    offset-x="20"
                    offset-y="20"
            >
                <template v-slot:badge>
                    {{selected.length}}
                </template>
                <v-btn fab dark color="indigo" class="white--text mt-2"
                       @click="loadClipBoard()">
                    <v-icon>mdi-clipboard-outline</v-icon>
                </v-btn>
            </v-badge>
        </div>

        <v-virtual-scroll
                :items="notes"
                :item-height="65"
                :height="height"
        >
            <template v-slot=" { item,index } ">
                <v-list-item @click="Select(index)"
                             dense
                             :class="{'v-list-item--active':selected.includes(item), 'pl-2': true}"
                             :color="selected.includes(item)?'indigo darken-2':''" >
                    <v-list-item-avatar tile size="50" @click.stop="playNote(item)">
                        <v-img v-if="item.notetype==='video' || item.notetype==='marker'" :src="getImage(item)">
                            <v-icon class="awesome--text lighten-2 ol">mdi-play</v-icon>
                        </v-img>
                        <v-icon v-else class="grey lighten-1 white--text">{{icons.openquote}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-2 font-weight-light">
                            {{item.notesdata.note || 'no text'}}
                        </v-list-item-title>
                        <v-list-item-subtitle class="font-weight-light">
                            by {{item.useremail}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-light">
                            {{ new Date(item.createdAt).toDateString()}}
                            {{new Date(item.createdAt).toLocaleTimeString()}}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="hidden-xs-only">
                        <!--                            <v-checkbox v-if="select" v-model="selected" :value="n"></v-checkbox>-->
                        <v-list-item-action-text>{{item.notetype}}</v-list-item-action-text>
                    </v-list-item-action>
                </v-list-item>
            </template>
        </v-virtual-scroll>
    </v-card>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'

  export default {
    name: "Notes",
    props: ['bookkey', 'api', 'title', 'path', 'tag', 'notes','height'],
    data() {
      return {
        headers: [
          {text: 'Note', value: 'note'},
          {text: 'Date', value: 'createdAt'},
        ],
        offset: 0,
        limit: 8,
        d: [],////break
        noteindex: 3,
        note: undefined,
        loading: true,
        playing: false,
        src: undefined,
        poster: undefined,
        select: false,
        selected: [],
        prv: true,
        nxt: true
      }
    },
    mounted() {
      window.onpopstate = function (event) {
        console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
      };
      console.log(this.$vuetify.breakpoint)
    },
    watch: {
      notes() {
        this.select = false
      },
      tag(n) {
        if (n) {
        }
      },
      select(n) {
        if (!n) {
          this.selected = false
        } else {
          this.selected = []
        }
      },
      selected(n) {
        this.$emit('selected', n)
      }
    },
    computed: {
      ...mapState(['icons']),
    },
    methods: {
      ...mapActions(['post', 'get', 'playNotes']),
      ...mapMutations(['setClipBoard']),
      Select(index) {
        console.log(index)
        if (this.selected.includes(this.notes[index])) {
          this.selected.splice(this.selected.indexOf(this.notes[index]), 1)
        } else {
          this.selected.push(this.notes[index])
        }
      },
      getImage(n) {
        return (n.notetype === 'marker') ? n.notesdata.poster : n.notesdata.locationframe
      },
      async loadClipBoard() {
        let data = {
          description: "Description",
          name: "Name",
          partkey: false,
          sortkey: false,
          shortid: false,
          notes: this.selected,
          edit: true //ie its your own list you can manipulate it
        }
        this.setClipBoard(data)
        this.selected = []
        console.log(this.selected)
      },
      async addText(n) {
        console.log(n)
        this.pause()
        return
        this.saving = true;
        // this.fname = this.$store.state.orgkey + '/' + Math.floor(1000000000 * Math.random());
        let data = {
          type: 'video',
          tag: this.notetags,
          partkey: this.video.partkey,
          sortkey: this.video.sortkey,
          notestart: (Math.round(this.notestart * 100) / 100),
          noteduration: (Math.round(this.noteduration * 100) / 100),
          body: this.notetext,
          noteplaybackrate: this.noteplaybackrate,
          locationframe: this.imgurl + this.fname + '.jpg',
          poster: this.poster,
          src: [{type: 'video/mp4', src: this.src}]
        }
        let response = await this.put({path: 'api/notes/save', body: data})
        this.saving = false
        this.shownotetools = false;
        this.notetext = '';
        this.saveimage()
        this.notesInVideo()
      },
      playNote(n) {
        //must pass in an array
        console.log(n)
        this.playNotes({list: [n], index: 0})
      }
    }
  }
</script>

<style scoped>
    .ol {
        color: #0f2944;
        -webkit-text-fill-color: #0f2944; /* Will override color (regardless of order) */
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: #FFFFFFdd;
        transform: scale(1.2);
    }
</style>